import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../utils';
import { partnerApiPath } from '../apiPath';
import { partnerHttpClient } from '../httpClient';

const PlatformAccessSchema = z
  .object({
    platform: z.string(),
    companyId: z.string(),
  })
  .describe('PlatformAccessSchema');

const GetPartnerMeResponseDataSchema = z
  .object({
    loginId: z.string(),
    platform: z.string(),
    companyId: z.string(),
    availablePlatforms: z.array(PlatformAccessSchema),
  })
  .describe('GetPartnerMeResponseDataSchema');

const GetPartnerMeResponseSchema = createApiResponseSchema(GetPartnerMeResponseDataSchema);

export type GetPartnerMeResponse = z.infer<typeof GetPartnerMeResponseSchema>;

/** GET `/v1/partner/me` — 파트너 본인 정보 조회 */
export const getPartnerMe = withApiErrorCapture(
  lazyPipe(
    () =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetPartnerMeResponse>(partnerApiPath.getMe),
      ),
    validateApiResponse(GetPartnerMeResponseSchema),
  ),
);
